export default __webpack_public_path__ + "static/media/chat_dark.2edf922c.svg";